// ElementControls 返回元素控制配置信息
// 参数  name 元素自定义标识（用于匹配对应配置信息）
// 返回值 配置信息
function ElementControls(name) {
    let elementInfo = [];
    if(sessionStorage.getItem('elementsInfo')) {
        elementInfo = JSON.parse(sessionStorage.getItem('elementsInfo'));
    }
    let val = '';
    elementInfo.some(item => {
        if(item.elecustomuid == name) {
            val = item.val!==null?item.val:item.defeleval;
            return true;
        }
    })
    return val;
}
export {
    ElementControls
}


// WEBPACK FOOTER //
// ./src/util/ElementControl.js